/**
 * Warning message displayed when uploaded surveys lack depth (Z) values.
 * Used across scenario-related components (HeaderButtons, ScenarioSticks, RingFenceTab).
 */
export const DEPTH_MISSING_WARNING =
  "One or more uploaded surveys do not have depth (Z) values. Sticks will not be plotted on the XDA view without depth data.";
